import _reduce from 'lodash/reduce';
import {
  START_ROUTES,
  ACCOUNT_ROUTES,
  PROFILE_ROUTES,
  ROUTES_WITH_STEPPER,
  STEPPER_NAMES,
  CLAIM_FINISH_ROUTES,
} from 'constants/stepper.constants';

type StepDataType = Array<{
  stepNumber: number;
  stepName: string;
  isActive: boolean;
}>;

export const getTalentFlowStepsData = (pathname: string, primaryAccountId?: number): StepDataType => {
  if (!pathname || !ROUTES_WITH_STEPPER.includes(pathname)) return [];

  // for additional claim we don't need step 2,
  // hideOnAdditional will be indicator for this
  const stepsArray = [
    {
      stepName: STEPPER_NAMES.START,
      isActive: START_ROUTES.includes(pathname),
      hideOnAdditional: false,
    },
    { stepName: STEPPER_NAMES.ACCOUNT, isActive: ACCOUNT_ROUTES.includes(pathname), hideOnAdditional: true },
    {
      stepName: STEPPER_NAMES.PROFILE,
      isActive: PROFILE_ROUTES.includes(pathname),
      hideOnAdditional: false,
    },
    {
      stepName: STEPPER_NAMES.FINISH,
      isActive: CLAIM_FINISH_ROUTES.includes(pathname),
      hideOnAdditional: false,
    },
  ];

  let stepNumberCounter = 0;

  const mainSteps = _reduce(
    stepsArray,
    (result, item) => {
      if (primaryAccountId && item.hideOnAdditional) return result;
      stepNumberCounter += 1;
      return [...result, { stepName: item.stepName, isActive: item.isActive, stepNumber: stepNumberCounter }];
    },
    []
  );

  return mainSteps;
};
